import { TransactionFrontendModel } from "types/transactions";

export const initialValues: TransactionFrontendModel = {
  customerData: {
    address: {
      address1: "",
      address2: "",
      city: "",
      country: "",
      postal: "",
      province: "",
      street: "",
    },
    email: "",
    loyaltyCardNumber: "",
    name: "",
    nip: "",
    phone: "",
  },
  items: [
    {
      category: "",
      grossValue: "",
      maker: "",
      name: "",
      highPrecisionQuantity: undefined,
      sku: "",
      labels: [],
    },
  ],
  channelId: "",
  header: {
    documentNumber: "",
    documentType: "sell",
    labels: [],
    purchasedAt: undefined,
    purchasePlace: "",
    linkedDocumentNumber: undefined,
  },
};
